<tds-icon [ngbTooltip]="message" [size]="size" name="info" placement="auto"></tds-icon>
